"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reporter = void 0;
var inversify_1 = require("inversify");
var event_tracking_core_1 = require("@al/event-tracking-core");
var types_1 = require("./types");
var utils_1 = require("./utils");
var notifyEvents_1 = require("./constants/notifyEvents");
var Reporter = /** @class */ (function () {
    function Reporter(applicationExecutor, observableService, configService, webGateway, nativeGateway, clickEventService, inputEventService, unloadEventService, visibilityEventService, clickEventObserver, inputEventObserver, unloadEventObserver, visibilityEventObserver, routeStackService, eventOrderBucket, removeLogsService, localStoreService, sessionStoreService, logDataStore, leaveOpsService, printLogService, sessionService, uploadTimerService) {
        this.applicationExecutor = applicationExecutor;
        this.observableService = observableService;
        this.configService = configService;
        this.webGateway = webGateway;
        this.nativeGateway = nativeGateway;
        this.clickEventService = clickEventService;
        this.inputEventService = inputEventService;
        this.unloadEventService = unloadEventService;
        this.visibilityEventService = visibilityEventService;
        this.clickEventObserver = clickEventObserver;
        this.inputEventObserver = inputEventObserver;
        this.unloadEventObserver = unloadEventObserver;
        this.visibilityEventObserver = visibilityEventObserver;
        this.routeStackService = routeStackService;
        this.eventOrderBucket = eventOrderBucket;
        this.removeLogsService = removeLogsService;
        this.localStoreService = localStoreService;
        this.sessionStoreService = sessionStoreService;
        this.logDataStore = logDataStore;
        this.leaveOpsService = leaveOpsService;
        this.printLogService = printLogService;
        this.sessionService = sessionService;
        this.uploadTimerService = uploadTimerService;
        this.enterTime = Date.now();
    }
    Reporter.prototype.prevLeave = function (data) {
        var now = Date.now();
        var createTime = data.createTime, rest = __rest(data, ["createTime"]);
        var leaveData = __assign({ offset: 0, eventType: types_1.EventType.View, duration: now - createTime, screenAction: types_1.ScreenAction.Leave }, rest);
        this.gateway.prevLeave(leaveData);
    };
    Reporter.prototype.asyncInitial = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // 如何优化，makePrevRouteLeave 会依赖 routeStatckService 异步完成
                // await this.routeStackService.init(config.appName);
                // await this.sessionService.init(this.configService.get().userId);
                this.leaveOpsService.makePrevRouteLeave();
                return [2 /*return*/];
            });
        });
    };
    Reporter.prototype.init = function (config) {
        this.config = config;
        var enabled = typeof config.enable === "undefined" ? true : config.enable;
        if (!enabled) {
            return;
        }
        this.printLogService.setEnabled(!!config.enableLog);
        // this.applicationExecutor.setEnabled(enabled);
        this.setSdkConfig(config);
        // this.adjustTimeService.init(config.localTimeService);
        var useNative = (0, utils_1.isUseNative)(config.isNative);
        this.logDataStore.init(config.appName);
        this.localStoreService.init(config.appName, "v4LocalStore");
        this.sessionStoreService.init(config.appName, "v4SessionStore");
        this.eventOrderBucket.init(this.localStoreService);
        // 订阅 core 内的路由离开完成事件，这时会去标记事件 isComplete 为 true，但可能订阅比事件发出更晚，没有接到事件
        // 因此 asyncInitial 内需要调用一次 makePrevRouteLeave
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ROUTE_LEAVE_COMPLETE, this.leaveOpsService);
        this.asyncInitial(config);
        if (useNative) {
            this.gateway = this.nativeGateway.init(config);
        }
        else {
            this.gateway = this.webGateway.init(config);
            this.unloadEventService.monitor();
            this.unloadEventService.subscribe(this.unloadEventObserver);
        }
        this.visibilityEventService.monitor();
        this.visibilityEventService.subscribe(this.visibilityEventObserver);
        this.clickEventService.monitor();
        this.inputEventService.monitor();
        this.clickEventService.subscribe(this.clickEventObserver);
        this.inputEventService.subscribe(this.inputEventObserver);
        // 定时上报
        this.uploadTimerService.init();
        this.uploadTimerService.fire();
        // 定时删除数据
        this.removeLogsService.fire();
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ROUTE_LEAVE, this);
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_PREV_ROUTE_LEAVE, this);
        this.observableService.subscribe(notifyEvents_1.coreNotifyEvents.NOTIFY_ROUTE_RE_ENTER, this);
    };
    Reporter.prototype.setSdkConfig = function (config) {
        this.configService.set({
            env: config.env,
            isNative: config.isNative,
            appName: config.appName,
            appVersion: config.appVersion,
            countryId: config.countryId,
            uploadDomain: config.uploadDomain,
            appBrand: config.appBrand,
            userId: config.userId,
            deviceId: config.deviceId,
            deviceUuid: config.deviceUuid,
            smDeviceId: config.smDeviceId,
            sessionId: config.sessionId,
            adjustId: config.adjustId,
            googleAdId: config.googleAdId,
            intersectionRootMargin: config.intersectionRootMargin,
            nativeLogHandler: config.nativeLogHandler,
        });
    };
    Reporter.prototype.updateSdkConfig = function (config) {
        this.configService.update(config);
    };
    Reporter.prototype.setPageConfig = function (config) {
        if (this.gateway) {
            this.gateway.setPageConfig(config);
        }
    };
    Reporter.prototype.getPageConfig = function () {
        var _a;
        return (_a = this.gateway) === null || _a === void 0 ? void 0 : _a.getPageConfig();
    };
    Reporter.prototype.enter = function (data) {
        var _this = this;
        this.applicationExecutor.callWhenPrepared(function () { return __awaiter(_this, void 0, void 0, function () {
            var sessionExpired, enterData;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.eventOrderBucket.resetInputOrder();
                        return [4 /*yield*/, this.sessionService.isExpired()];
                    case 1:
                        sessionExpired = _b.sent();
                        if (!sessionExpired) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.eventOrderBucket.resetClickOrder()];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        enterData = __assign({ offset: 0, eventType: types_1.EventType.View, duration: 0, screenAction: types_1.ScreenAction.Enter }, data);
                        (_a = this.gateway) === null || _a === void 0 ? void 0 : _a.enter(enterData);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    Reporter.prototype.leave = function (data) {
        var _this = this;
        this.applicationExecutor.callWhenPrepared(function () {
            var _a;
            var now = Date.now();
            var leaveData = __assign({ offset: 0, eventType: types_1.EventType.View, duration: now - _this.enterTime, screenAction: types_1.ScreenAction.Leave }, data);
            _this.routeStackService.leave();
            (_a = _this.gateway) === null || _a === void 0 ? void 0 : _a.leave(leaveData);
        });
    };
    Reporter.prototype.click = function (data, event) {
        var _this = this;
        console.log(data, "data click");
        this.applicationExecutor.callWhenPrepared(function () {
            var _a;
            var clickData = __assign({ eventType: types_1.EventType.Click, offset: 0 }, data);
            (_a = _this.gateway) === null || _a === void 0 ? void 0 : _a.click(clickData);
        });
    };
    Reporter.prototype.popClick = function (data, event) {
        // v4 无此事件，占位
    };
    Reporter.prototype.activityEnter = function (data) {
        //
    };
    Reporter.prototype.activityClick = function (data, event) {
        //
    };
    Reporter.prototype.activityInput = function (data) {
        //
    };
    Reporter.prototype.expose = function (data) {
        var _this = this;
        this.applicationExecutor.callWhenPrepared(function () {
            var _a;
            var datas = [];
            if (Array.isArray(data)) {
                datas = data;
            }
            else {
                datas = [data];
            }
            datas = datas.map(function (item) {
                return __assign(__assign({ eventType: types_1.EventType.Expose, offset: 0 }, item), { isComplete: false });
            });
            (_a = _this.gateway) === null || _a === void 0 ? void 0 : _a.expose(datas);
        });
    };
    Reporter.prototype.input = function (data) {
        var _this = this;
        this.applicationExecutor.callWhenPrepared(function () {
            var _a;
            var inputData = {
                eventType: types_1.EventType.Input,
                offset: 0,
                data: data,
            };
            (_a = _this.gateway) === null || _a === void 0 ? void 0 : _a.input(inputData);
        });
    };
    // enableAutoExpose(): void {
    //   this.applicationExecutor.callWhenPrepared(() => {
    //     this.gateway.enableAutoExpose();
    //   });
    // }
    // stopExposeMonitor(): void {
    //   this.applicationExecutor.callWhenPrepared(() => {
    //     this.gateway.stopExposeMonitor();
    //   });
    // }
    // reCollectExposeItems(): void {
    //   this.applicationExecutor.callWhenPrepared(() => {
    //     this.gateway.reCollectExposeItems();
    //   });
    // }
    // exposeAfterReCollect(config: ExposeAfterReCollectConfig): void {
    //   this.applicationExecutor.callWhenPrepared(() => {
    //     this.gateway.exposeAfterReCollect(config);
    //   });
    // }
    Reporter.prototype.update = function (data, eventType) {
        var _this = this;
        if (eventType === notifyEvents_1.coreNotifyEvents.NOTIFY_ROUTE_LEAVE ||
            eventType === notifyEvents_1.coreNotifyEvents.NOTIFY_PREV_ROUTE_LEAVE) {
            this.applicationExecutor.callWhenPrepared(function () {
                _this.prevLeave(data);
            });
        }
        else if (eventType === notifyEvents_1.coreNotifyEvents.NOTIFY_ROUTE_RE_ENTER) {
            this.enter();
        }
    };
    Reporter.prototype.subscribe = function (eventType, observer) {
        this.observableService.subscribe(eventType, observer);
    };
    Reporter.prototype.unsubscribe = function (eventType, observer) {
        this.observableService.subscribe(eventType, observer);
    };
    Reporter = __decorate([
        (0, inversify_1.injectable)(),
        __param(0, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IApplicationExecutor)),
        __param(1, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObservableService)),
        __param(2, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IConfigService)),
        __param(2, (0, inversify_1.named)(types_1.TAG.SDKConfigService)),
        __param(3, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IReportService)),
        __param(3, (0, inversify_1.named)(types_1.TAG.WebGateway)),
        __param(4, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IReportService)),
        __param(4, (0, inversify_1.named)(types_1.TAG.NativeGateway)),
        __param(5, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventObservable)),
        __param(5, (0, inversify_1.named)(event_tracking_core_1.TAG.ClickEventService)),
        __param(6, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventObservable)),
        __param(6, (0, inversify_1.named)(event_tracking_core_1.TAG.InputEventService)),
        __param(7, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventObservable)),
        __param(7, (0, inversify_1.named)(event_tracking_core_1.TAG.UnloadEventService)),
        __param(8, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventObservable)),
        __param(8, (0, inversify_1.named)(event_tracking_core_1.TAG.VisibilityEventService)),
        __param(9, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObserver)),
        __param(9, (0, inversify_1.named)(types_1.TAG.ClickEventObserver)),
        __param(10, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObserver)),
        __param(10, (0, inversify_1.named)(types_1.TAG.InputEventObserver)),
        __param(11, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObserver)),
        __param(11, (0, inversify_1.named)(types_1.TAG.UnloadEventObserver)),
        __param(12, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IObserver)),
        __param(12, (0, inversify_1.named)(types_1.TAG.VisibilityEventObserver)),
        __param(13, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IRouteStackService)),
        __param(14, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IEventOrderBucket)),
        __param(14, (0, inversify_1.named)(types_1.TAG.EventOrderBucket)),
        __param(15, (0, inversify_1.inject)(types_1.TYPES.IRemoveLogsService)),
        __param(16, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IStoreService)),
        __param(16, (0, inversify_1.named)(types_1.TAG.LocalStoreService)),
        __param(17, (0, inversify_1.inject)(event_tracking_core_1.TYPES.IStoreService)),
        __param(17, (0, inversify_1.named)(types_1.TAG.SessionStoreService)),
        __param(18, (0, inversify_1.inject)(types_1.TYPES.ILogDataStore)),
        __param(19, (0, inversify_1.inject)(types_1.TYPES.ILeaveOpsService)),
        __param(20, (0, inversify_1.inject)(types_1.TYPES.IPrintLogService)),
        __param(21, (0, inversify_1.inject)(event_tracking_core_1.TYPES.ISessionService)),
        __param(22, (0, inversify_1.inject)(types_1.TYPES.IUploadTimerService)),
        __metadata("design:paramtypes", [Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object, Object])
    ], Reporter);
    return Reporter;
}());
exports.Reporter = Reporter;
